import * as React from 'react'
import * as PropTypes from 'prop-types'

import { Paragraph } from '../../paragraph'
import { isElement } from '../../../utils'

interface IParagraphRendererProps {
  children?: React.ReactNode
  tag?: string | React.ComponentType<{}>
}

function ParagraphRenderer({ children, tag }: IParagraphRendererProps) {
  let t = tag
  const firstChild = React.Children.toArray(children)[0]

  if (
    firstChild &&
    isElement(firstChild) &&
    firstChild.props.href &&
    firstChild.props.href.indexOf('dooer:video:') > -1
  ) {
    t = 'div'
  }

  return (
    <Paragraph style={{ ':last-child': { marginBottom: 0 } }} tag={t} wide>
      {children}
    </Paragraph>
  )
}

ParagraphRenderer.displayName = 'ParagraphRenderer'

ParagraphRenderer.propTypes = {
  tag: PropTypes.string,
  children: PropTypes.node,
}

export default ParagraphRenderer
